module.exports = __webpack_public_path__ + "img/hmpg-bluetime.b0f3bdb9.svg";